import React, { useState } from 'react';
import { Tag, Typography, Tooltip, Button } from 'antd';
import { TrophyOutlined } from '@ant-design/icons';

const SHOWN = 5;

// A badge's label: the name, plus its Year-Month when it has one
// (e.g. "Most Calls Handled 2026-08").
export const badgeLabel = (b) => (b.YearMonth ? `${b.BadgeName} ${b.YearMonth}` : b.BadgeName);

// Current badges on the agent summary strip: the first five, and the rest
// behind "+N more". The list arrives already filtered to unexpired badges and
// ordered newest month first. Hovering a badge shows its Special Note, or the
// badge's description when it has none.
export default function AgentBadges({ badges }) {
  const [expanded, setExpanded] = useState(false);
  if (!badges?.length) return null;
  const visible = expanded ? badges : badges.slice(0, SHOWN);
  const hidden  = badges.length - SHOWN;
  return (
    <div style={{ flex: '1 1 320px', minWidth: 0 }}>
      <Typography.Text type="secondary" style={{ fontSize: 11 }}>Badges</Typography.Text><br />
      <div style={{ display: 'flex', flexWrap: 'wrap', gap: 4, marginTop: 2, alignItems: 'center' }}>
        {visible.map((b) => (
          <Tooltip key={b.ID} title={b.SpecialNote || b.BadgeDescription || undefined}>
            <Tag color="gold" icon={<TrophyOutlined />} style={{ marginInlineEnd: 0 }}>{badgeLabel(b)}</Tag>
          </Tooltip>
        ))}
        {hidden > 0 && (
          <Button type="link" size="small" style={{ padding: 0, height: 'auto' }} onClick={() => setExpanded(!expanded)}>
            {expanded ? 'Show less' : `+${hidden} more`}
          </Button>
        )}
      </div>
    </div>
  );
}
